import React from "react";
import { common_axios } from "../../../App.js";
export default function ResellerTable() {
  const getByData = async () => {
    try {
      const res = await common_axios(
        "https://jsonplaceholder.typicode.com/users"
      );
      console.log(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    getByData();
  }, []);

  return <h2>Hello</h2>;
}
